import React, { useEffect, useState } from 'react';

import { Checkbox, InputAdornment, makeStyles, TextField } from '@material-ui/core';
import Button from 'components/CustomButtons/Button.js';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

//tabla
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

import { wsFindBy } from 'services/WService';
import { ArrowDownward, ArrowUpward, Search } from '@material-ui/icons';
import { wsCreate } from 'services/WService';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    fontSize: '18px',
    fontWeight: 'bold'
  }
});

export default function BusinessLines(props) {
  const { promotion, showNotify, getPromotion } = props;
  const { defaultBusinessLinesProvider } = props;
  const classes = useStyles();

  const state = promotion.state == 'N' || promotion.state == 'G' ? false : true;

  const [businessLines, setBusinessLines] = useState([]);
  const [checkeds, setCheckeds] = useState([]);
  const [search, setSearch] = useState('');
  const [showLines, setShowLines] = useState(false);

  async function listBusinessLines(promo) {
    let bpId = parseInt(defaultBusinessLinesProvider) === 0 ? promo.base_business_partner_id : defaultBusinessLinesProvider;
    const response = await wsFindBy('base/business-line', {
      base_business_partner_id: bpId,
    });
    if (response.success) {
      setBusinessLines(response.data);
      const lines = promo.lines.map((item) => item.base_business_line_id);
      setCheckeds(lines);
      filterBusinessLines();
    }
  }

  const handleCheck = (isCheck, item) => {
    if (isCheck) {
      setCheckeds([...checkeds, item]);
    } else {
      const checks = [...checkeds];
      checks.splice(
        checks.findIndex((x) => x == item),
        1,
      );
      setCheckeds([...checks]);
    }
  };

  async function saveBusinessLines() {
    const response = await wsCreate(`prom/promotion/${promotion.id}/line`, {
      business_lines: checkeds,
    });
    if (response.success) {
      getPromotion();
      showNotify(response.message);
    } else {
      showNotify(response.message, 'error');
    }
  }

  const filterBusinessLines = (value) => {
    const arrayLines = [...businessLines];
    let filter = arrayLines;
    if (value?.length > 0) {
      filter = arrayLines.filter((item) =>
        item.description?.toLowerCase().includes(value?.toLowerCase()),
      );
    }
    return filter;
  };

  useEffect(() => {
    if (promotion.id === undefined) return;
    if(defaultBusinessLinesProvider === -1) return;
    listBusinessLines(promotion);
  }, [defaultBusinessLinesProvider]);

  return (
    <GridItem xs={12}>
      <Card>
        <CardHeader icon>
          <CardIcon color="info" pointer onClick={() => setShowLines(!showLines)}>
            {showLines ? <ArrowUpward /> : <ArrowDownward />}
          </CardIcon>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span className={classes.cardIconTitle}>Giros de negocio</span>
            {showLines ? (
              <TextField
                size="small"
                margin="normal"
                placeholder="Buscar por descripción..."
                onChange={(e) => setSearch(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            ) : undefined}
          </div>
        </CardHeader>
        <CardBody>
          {!showLines ? (
            <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Existen {checkeds?.length} seleccionados
              <span style={{ fontWeight: 'normal', fontSize: '14px', marginLeft: '15px' }}>
                (Presione flecha abajo para ver o modificar)
              </span>
            </span>
          ) : (
            <>
              <TableContainer component={Paper} style={{ maxHeight: '450px' }}>
                <Table sx={{ minWidth: 1000 }} size="small" stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>
                        <Checkbox
                          disabled={state}
                          indeterminate={
                            businessLines?.length > checkeds?.length && checkeds?.length > 0
                          }
                          checked={checkeds?.length === businessLines?.length}
                          onChange={(e) => {
                            const isCheck = e.target.checked;
                            if (isCheck) {
                              setCheckeds(businessLines.map((item) => item.id?.toString()));
                            } else {
                              setCheckeds([]);
                            }
                          }}
                          inputProps={{ 'aria-label': 'primary checkbox' }}
                        />
                        #
                      </TableCell>
                      <TableCell>Código</TableCell>
                      <TableCell>Descripción</TableCell>
                      <TableCell>Estado</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filterBusinessLines(search).map((item, i) => {
                      return (
                        <TableRow key={i}>
                          <TableCell>
                            <Checkbox
                              checked={checkeds.includes(item.id?.toString())}
                              onChange={(e) => handleCheck(e.target.checked, item.id?.toString())}
                              inputProps={{ 'aria-label': 'primary checkbox' }}
                              disabled={state}
                            />
                          </TableCell>
                          <TableCell>{item.code}</TableCell>
                          <TableCell>{item.description}</TableCell>
                          <TableCell>{item.state === 'A' ? 'Activo' : 'Inactivo'}</TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              <Button
                style={{ float: 'right', marginTop: '15px' }}
                color="success"
                onClick={saveBusinessLines}
                disabled={state}
              >
                Guardar
              </Button>
            </>
          )}
        </CardBody>
      </Card>
    </GridItem>
  );
}
